import React from 'react';
import { useTheme } from '@glu/theming';
import useLocale from 'components/useLocale';
import { useStyles } from './print.styles';

const PrintLogo = () => {
  const locale = useLocale();
  const { logo, logoWrapper } = useStyles();
  const {
    images: {
      logos: { login: bankLogo }
    }
  } = useTheme();

  return (
    <div className={logoWrapper}>
      <img
        data-qa="bank-logo"
        className={logo}
        src={bankLogo}
        alt={locale['customReporting.logo']}
      />
    </div>
  );
};

export default PrintLogo;
